
import { defineComponent } from "vue";
import { tapBarList } from "../config/topBar";
import { mapState, mapMutations } from "vuex";
const logo =
    "https://virutalbuy-public.oss-cn-hangzhou.aliyuncs.com/xuhui/img/wht-logo.png";

export default defineComponent({
    name: "TopBar",
    props: {},
    computed: {
        ...mapState(["curMenu"]),
    },
    data() {
        return {
            tapBarList,
            logo,
        };
    },
    created() {
        this.initCurMenu();
    },
    watch: {
        "$route.path": function() {
            this.initCurMenu();
        }
    },
    methods: {
        ...mapMutations(["setCurMenu"]),
        selectMenu(menu: string) {
            console.log("menuChange", menu);
            this.$router.push({ path: menu });
            this.setCurMenu(menu);
        },
        initCurMenu() {
            console.log("$route.name", this.$route.path);
            if ( this.$route.path === '/') {
                this.setCurMenu('home');
            } else {
                this.setCurMenu(this.$route.path.slice(1));
            }
        },
        openCasePage(path: string) {
            window.open(path)
        },
    },
});
